import { MutationTree } from 'vuex';
import { ForexTemplateState } from '@/feature/TrHistory/store/template/interface';
import { ForexTemplateMutation } from '@/feature/TrHistory/store/template/constants';
import { ForexTemplateItem, ForexTemplateWithDraft } from '@/feature/TrHistory/api/template/forex-template.interface';
import { mapForexTemplate } from '@/feature/TrHistory/api/template/forex-template.utils';

export default <MutationTree<ForexTemplateState>> {

	[ForexTemplateMutation.addList](state, list: ForexTemplateItem[]) {
		state.list.push(...list);
	},

	[ForexTemplateMutation.setNextPage](state) {
		state.pageNumber++;
	},

	[ForexTemplateMutation.resetPage](state) {
		state.pageNumber = 1;
		state.isEndPage = false;
		state.list = [];
	},

	[ForexTemplateMutation.setIsEndPage](state, isEndPage: boolean) {
		state.isEndPage = isEndPage;
	},

	[ForexTemplateMutation.setLoading](state, loading: boolean) {
		state.loadingCount += loading ? 1 : (state.loadingCount && -1);
	},

	[ForexTemplateMutation.resetCurrentTemplate](state) {
		state.currentTemplate = mapForexTemplate();
	},

	[ForexTemplateMutation.resetList](state) {
		state.list = [];
	},

	[ForexTemplateMutation.setList](state, list: ForexTemplateItem[]) {
		state.list = list;
	},

	[ForexTemplateMutation.deleteTemplate](state, templateId: number) {
		const index = state.list.findIndex(
			item => item.templateId === templateId
		);

		index > -1 && state.list.splice(index, 1);
	},

	[ForexTemplateMutation.setCurrentTemplate](state, template: ForexTemplateWithDraft) {
		state.currentTemplate = template;
	},

	[ForexTemplateMutation.updateCurrentTemplate](state, template?: ForexTemplateWithDraft) {
		Object.assign(state.currentTemplate, template || {});
	},

}
